import { useDisclosure, Collapse, Box, Heading } from "@chakra-ui/react";
import { ChevronDownIcon, ChevronRightIcon } from "@chakra-ui/icons";
import { ReactNode } from "react";

export interface CollapseListProps {
   description: string;
   children: ReactNode;
   title: string;
   rightNode: ReactNode;
}

const CollapseList = ({
   children,
   title,
   rightNode,
   description,
}: CollapseListProps) => {
   const { isOpen, onToggle } = useDisclosure();
   return (
      <Box>
         <Box w="full" display="grid" gridTemplateColumns="auto 1fr" pb=".5rem">
            <Box
               display="grid"
               alignItems="center"
               gap=".5rem"
               gridTemplateColumns="auto auto"
            >
               {isOpen ? <ChevronDownIcon /> : <ChevronRightIcon />}
               <Heading fontSize={16} onClick={onToggle} cursor="pointer">
                  {title}
               </Heading>
            </Box>
            <Box justifySelf="end">{rightNode}</Box>
         </Box>
         <Box>{description}</Box>
         <Collapse in={isOpen} animateOpacity>
            <Box color="brandPrimary.900" bg="transparent" mt="4">
               {children}
            </Box>
         </Collapse>
      </Box>
   );
};

export default CollapseList;
